<template>
  <div class="container" v-loading="loading">
    <div class="my-3">
      <b-card>
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <b-form  id="form" @submit.stop.prevent="passes(onSubmit)">
            <div class="row" id="imageDiv">
              <div class="col-md-6 col-lg-4">
                <b-form-group>
                  <el-upload
                    class="upload-demo d-flex flex-column"
                    ref="imageUpload"
                    :action="sharedUrl"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :file-list="fileList"
                    list-type="picture-card"
                    accept=".jpg, .jpeg, .png"
                    :before-upload="beforeAvatarUpload"
                    :limit="imageLimit"
                    :on-exceed="maxFileReached"
                    :auto-upload="false"
                    multiple
                  >
                    <div class="form-control">
                      {{lang.label.chooseImage}}
                      <i class="sprite ic-image float-right"></i>
                    </div>
                    <div
                      slot="tip"
                      class="el-upload__tip"
                    >
                      {{lang.label.note}}: {{lang.label.imageNote}}
                    </div>
                    <span class="error" v-if="onlyImage">{{lang.label.onlyImage}}</span>

                  </el-upload>
                  <div style="margin-top:-10px">
                    <span class="error " v-if="noFilesChosen">{{lang.label.imgError}}</span>
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6 col-lg-4">
                <b-form-group>
                  <el-upload
                    class="upload-demo"
                    ref="pdfUpload"
                    :action="sharedUrl"
                    :on-preview="handlePreview"
                    :on-change="handleChangePdf"
                    :before-upload="beforeAvatarUpload"
                    :on-remove="handleRemovePdf"
                    :file-list="fileList"
                    list-type="text"
                    :on-exceed="maxPdfReached"
                    accept="application/pdf"
                    :limit="pdfLimit"
                    :auto-upload="false"
                  >
                    <div class="form-control">
                      {{lang.label.attachments}}
                      <i class="sprite ic-pdf float-right"></i>
                    </div>
                    <div
                      slot="tip"
                      class="el-upload__tip"
                    >
                      {{lang.label.note}}: {{lang.label.pdfNote}}
                    </div>
                    <span class="error" v-if="onlyPdf">{{lang.label.onlyPdf}}</span>
                  </el-upload>
                  <span class="error" v-if="noFilesChosen">{{lang.label.pdfError}}</span>
                </b-form-group>
              </div>
              <div class="col-md-6 col-lg-4">
                <b-form-group>
                  <ValidationProvider name="ICD10 codes" v-slot="validationContext">
                    <vue-bootstrap-typeahead
                            id="icd10Code"
                            ref="icd10Code"
                            v-model="models.icdCode"
                            :data="icdCodeList"
                            :minMatchingChars= 1
                            :state="getValidationState(validationContext)"
                            :serializer="s => s.icdCode"
                            :placeholder="lang.label.placeholder.enterIcdCode"
                    >
                      <template slot="suggestion" slot-scope="{ data, htmlText }">
                        <span v-html="htmlText"></span><br />
                      </template>
                    </vue-bootstrap-typeahead>
                  </ValidationProvider>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h6 class="heading-title">{{lang.label.patientDetails}}</h6>
                <span class="error" v-if="selectEmailOrMobilePatient">{{lang.label.selectOne}}</span>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="name">
                    {{lang.label.patientName}}:
                    <span class="text-danger">*</span>
                  </label>
                  <ValidationProvider
                    name="Name of Patient"
                    :rules="needToValidate ? {required:true} : ''"
                    v-slot="validationContext"
                  >
                    <vue-bootstrap-typeahead
                            id="patientName"
                            ref="patientName"
                            v-model="models.patientName"
                            :data="patientList"
                            :minMatchingChars= 1
                            :state="getValidationState(validationContext)"
                            :serializer="s => s.name"
                            :placeholder="lang.label.placeholder.enterName"
                            @hit="selectedPatient = $event"
                    >
                    <template slot="suggestion" slot-scope="{ data, htmlText }">
                      <span v-html="htmlText"></span><br />
                      <small v-html="data.mobile"></small>
                    </template>
                    </vue-bootstrap-typeahead>
                    <span v-if="validationContext.errors[0] && !nameError" class="error">{{validationContext.errors[0]}}</span>
                    <span v-else-if="nameError" class="error">{{lang.label.nameError}}</span>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="name">
                    {{lang.label.mobileNumber}}:
                  </label>
                  <ValidationProvider
                    name="mobile number"
                    rules="digits:10"
                    v-slot="validationContext"
                    class="phone-input-group"
                  >
                    <b-form-input
                      :state="getValidationState(validationContext)"
                      v-model="models.mobileNumber"
                      type="text"
                      @keypress="isNumber(1,$event)"
                      id="mobileError"
                      :placeholder="lang.label.placeholder.enterMobileNumber"
                    ></b-form-input>
                    <span>{{lang.label.mobileExample}}</span><br />
                    <span class="error" v-if="mobileError && !mobileRequired">{{lang.label.mobileError}}</span>
                    <span class="error" v-if="mobileRequired && !mobileError">{{lang.label.mobileRequired}}</span>
                    <!--<b-form-invalid-feedback v-if="!mobileError && !mobileRequired">{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                   <b-form-invalid-feedback  v-if="validationContext.failedRules.digits && !mobileError && !mobileRequired">{{lang.label.validationMessages.mobilenumLength}}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="email">{{lang.label.emailId}}:</label>
                  <ValidationProvider name="Email ID" rules="email" v-slot="validationContext">
                    <b-form-input
                      :state="getValidationState(validationContext)"
                      v-model="models.emailId"
                      type="text"
                      :placeholder="lang.label.placeholder.enterEmailId"
                    ></b-form-input>
                    <span class="error" v-if="emailErrorPatient">{{lang.label.mobileError}}</span>
                   <b-form-invalid-feedback v-if="validationContext.failedRules.email">{{lang.label.validationMessages.emailFormat}}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <template>
                <div class="col-md-4">
                  <b-form-group>
                    <label class="label-control" for="idNumber">{{lang.label.idNumber}}:</label>
                    <ValidationProvider name="ID Number" v-slot="validationContext">
                      <b-form-input
                              :state="getValidationState(validationContext)"
                              v-model="models.idNumber"
                              type="text"
                              :placeholder="lang.label.placeholder.enterIDNumber"
                      ></b-form-input>
  <!--                    <span class="error" v-if="emailErrorPatient">{{lang.label.mobileError}}</span>-->
  <!--                    <b-form-invalid-feedback v-if="validationContext.failedRules.email">{{lang.label.validationMessages.emailFormat}}</b-form-invalid-feedback>-->
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <!--<div class="col-md-4">
                  <b-form-group>
                    <label class="label-control" for="idNumber">{{lang.label.icdCode}}:</label>
                    <ValidationProvider name="ICD10 codes" v-slot="validationContext">
                      <vue-bootstrap-typeahead
                              id="icd10Code"
                              ref="icd10Code"
                              v-model="models.icdCode"
                              :data="icdCodeList"
                              :minMatchingChars= 1
                              :state="getValidationState(validationContext)"
                              :serializer="s => s.icdCode"
                              :placeholder="lang.label.placeholder.enterIcdCode"
                      >
                        <template slot="suggestion" slot-scope="{ data, htmlText }">
                          <span v-html="htmlText"></span><br />
                        </template>
                      </vue-bootstrap-typeahead>
                    </ValidationProvider>
                  </b-form-group>
                </div>-->
                <div class="col-md-4">
                  <b-form-group>
                    <ValidationProvider name="patient Minor" v-slot="validationContext">
                      <b-form-group>
                        <b-form-checkbox-group
                                v-model="models.patientMinor"
                                :options="status"
                                text-field="name"
                                value-field="item"
                                class="mt-4 pt-2"
                                value="true"
                                unchecked-value="false"
                        ></b-form-checkbox-group>
                      </b-form-group>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group>
                    <label class="label-control" for="parentName">{{lang.label.parentName}}:</label>
                    <ValidationProvider name="Parent Name" v-slot="validationContext">
                      <b-form-input
                              :state="getValidationState(validationContext)"
                              v-model="models.parentName"
                              type="text"
                              :placeholder="lang.label.placeholder.parentName"
                      ></b-form-input>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group>
                    <label class="label-control" for="Parent/Guardian ID Number">{{lang.label.parentIDNumber}}:</label>
                    <ValidationProvider name="Parent/Guardian ID Number" v-slot="validationContext">
                      <b-form-input
                              :state="getValidationState(validationContext)"
                              v-model="models.parentIDNumber"
                              type="text"
                              :placeholder="lang.label.placeholder.parentIDNumber"
                      ></b-form-input>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-4">
                  <b-form-group>
                    <label class="label-control" for="name">
                      {{lang.label.medicineRequired}}:
                    </label>
                    <ValidationProvider
                            name="prescription"
                            v-slot="validationContext"
                    >
                      <b-form-textarea
                              :state="getValidationState(validationContext)"
                              v-model="models.medicineRequired"
                              type="text"
                              :placeholder="lang.label.placeholder.medicineRequired"
                              rows="3"
                              max-rows="3"
                              disabled
                      ></b-form-textarea>
                      <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.medicineRequired}}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-4">
                <b-form-group>
                  <label class="label-control" for="name">
                    {{lang.label.specialInstructions}}:
                  </label>
                  <ValidationProvider
                          name="prescription"
                          v-slot="validationContext"
                  >
                    <b-form-textarea
                            :state="getValidationState(validationContext)"
                            v-model="models.specialInstructions"
                            type="text"
                            :placeholder="lang.label.placeholder.medicineRequired"
                            rows="3"
                            max-rows="3"
                    ></b-form-textarea>
                    <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.medicineRequired}}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
              </template>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="dob">{{lang.label.dob}}:</label>
                  <el-date-picker name="dob" format="dd/MM/yyyy" v-model="models.dob" :picker-options="datePickerOptions" type="date" :placeholder="lang.label.placeholder.date"></el-date-picker>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <b-form-group>
                      <label class="label-control" for="gender">{{lang.label.gender}}:</label>
                      <el-select
                        v-model="models.gender"
                        :placeholder="lang.label.placeholder.selectGender"
                      >
                        <el-option v-for="item in gender" :key="item.value" :value="item.value"></el-option>
                      </el-select>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 col-12">
                    <b-form-group>
                      <label class="label-control" for="blood group">{{lang.label.bloodGroup}}:</label>
                      <el-select
                        v-model="models.bloodGroup"
                        :placeholder="lang.label.placeholder.selectBloodGroup"
                      >
                        <el-option v-for="item in bloodGroup" :key="item.value" :value="item.value"></el-option>
                      </el-select>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="blood group">{{lang.label.address}}:</label>
                  <b-form-textarea
                    style="height: 40px"
                    v-model="models.address"
                    :placeholder="lang.label.placeholder.enterAddress"
                    rows="1"
                    max-rows="1"
                  ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h6 class="heading-title">{{lang.label.pharmacistDetails}}</h6>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="name">
                    {{lang.label.pharmacistName}}:
                  </label>
                  <ValidationProvider
                    name="Name of Pharmacist"
                    v-slot="validationContext"
                  >
                    <vue-bootstrap-typeahead
                            v-if="!isPharmacyReadonly"
                            id="pharmacistName"
                            ref="pharmacistName"
                            v-model="modelsPharmacist.name"
                            :data="pharmacistList"
                             :minMatchingChars= 1
                            :state="getValidationState(validationContext)"
                            :serializer="s => s.name"
                            :placeholder="lang.label.placeholder.enterName"
                            @hit="selectedPharmacist = $event"
                    >
                      <template slot="suggestion" slot-scope="{ data, htmlText }">
                        <span v-html="htmlText"></span><small v-if="data.location" v-html="' -'+data.location"></small><br />
                        <small v-html="data.mobile"></small>
                      </template>
                    </vue-bootstrap-typeahead>
                    <b-form-input
                            v-else
                            id="pharmacistName"
                            v-model="modelsPharmacist.name"
                            :state="getValidationState(validationContext)"
                            type="text"
                            :placeholder="lang.label.placeholder.enterName"
                            readonly
                    ></b-form-input>
                  <span v-if="pharmaNameError" class="error" >{{lang.label.pharmaNameError}}</span>
                    <b-form-invalid-feedback v-if="!pharmaNameError">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="name">
                    {{lang.label.mobileNumber}}:
                  </label>
                  <ValidationProvider
                    name="mobile number"
                    rules="digits:10"
                    v-slot="validationContext"
                    class="phone-input-group"
                  >
                    <b-form-input
                      v-model="modelsPharmacist.number"
                      @keypress="isNumber(2,$event)"
                      :state="getValidationState(validationContext)"
                      type="text"
                      id="mobileErrorPharma"
                      :placeholder="lang.label.placeholder.enterMobileNumber"
                      :disabled="isPharmacyReadonly"
                    ></b-form-input>
                    <span>{{lang.label.mobileExample}}</span><br />
                  <span v-if="pharmaMobileError && !mobileErrorPharma" class="error" >{{lang.label.mobileRequired}}</span>
                    <span class="error" v-if="mobileErrorPharma && !pharmaMobileError">{{lang.label.mobileErrorPharma}}</span>
                    <!--<b-form-invalid-feedback v-if="!mobileErrorPharma">{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                   <b-form-invalid-feedback  v-if="validationContext.failedRules.digits && !mobileErrorPharma && !pharmaMobileError">{{lang.label.validationMessages.mobilenumLengthPharma}}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <label class="label-control" for="email">{{lang.label.emailId}}:</label>
                  <ValidationProvider name="Email ID" rules="email" v-slot="validationContext">
                    <b-form-input
                      v-model="modelsPharmacist.emailId"
                      :state="getValidationState(validationContext)"
                      type="text"
                      :placeholder="lang.label.placeholder.enterEmailId"
                      :disabled="isPharmacyReadonly"
                    ></b-form-input>
                    <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                   <b-form-invalid-feedback v-if="validationContext.failedRules.email">{{lang.label.validationMessages.emailFormatPharma}}</b-form-invalid-feedback>
                    <span v-if="emailError" class="error" >{{lang.label.email}}</span>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <ValidationProvider name="isRepeated" v-slot="validationContext">
                    <b-form-group>
                      <b-form-checkbox-group
                              v-model="models.isRepeated"
                              :options="repeatedStatus"
                              text-field="name"
                              value-field="item"
                              class="mt-4 pt-2 text-danger"
                              value="true"
                              unchecked-value="false"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-4" v-if="models.isRepeated && models.isRepeated.length > 0">
                <b-form-group>
                  <label class="label-control" for="repeatMonths">{{lang.label.repeatMonths}}</label>
                  <ValidationProvider
                    name="Repeat Duration"
                    :rules="models.isRepeated && models.isRepeated.length > 0 ? 'required' : ''"
                    v-slot="validationContext"
                  >
                    <el-select
                      v-model="models.repeatMonths"
                      @change="repeatMonthsError = false"
                      :placeholder="lang.label.placeholder.selectRepeatMonths"
                    >
                      <el-option v-for="item in repeatMonthsOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                    <span v-if="validationContext.failedRules.required || repeatMonthsError" class="error">
                      {{ lang.label.validationMessages.repeatMonthsRequired }}
                    </span>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-12" style="margin-top: -15px;margin-bottom: 10px;"><span class="error" v-if="selectEmailOrMobile">{{lang.label.selectOnePharma}}</span></div>
            </div>
            <div class="row justify-content-between">
              <div class="col-md-4">
                <b-form-group>
                  <ValidationProvider name="Tariff" rules="required"  v-slot="validationContext">
                  <div class="row">
                  <label class="label-control md-text col-3 col-md-4 col-lg-3 mt-1 pt-1 secondary-text" for="tariff">{{lang.label.tariff}}:</label>
                  <div class="col-9 col-md-8 col-lg-9">
                    <b-input-group prepend="R">
                      <b-form-input
                              id="tariff"
                              v-model="tariff"
                              @keypress="isNumber(3,$event)"
                              :state="getValidationState(validationContext)"
                              type="text"
                              :placeholder="lang.label.placeholder.entertariff"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                  </div>
                    <!---->
                    <span v-if="zeroValue && !validationContext.errors[0]" class="error">{{lang.label.tariffZero}}</span>
                    <span v-if="maxValue && !validationContext.errors[0]" class="error">{{lang.label.validationMessages.tariffMax}}</span>
                    <span v-if="validationContext.failedRules.required" class="error">{{lang.label.validationMessages.tariffRequired}}</span>
                  </ValidationProvider>
                </b-form-group>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-md-4">
                <b-form-group class="mb-0 btn-mt">
                  <b-btn
                    type="submit"
                    variant="primary"
                    class="w-100"
                    @click="createScript"
                  >{{lang.label.buttons.createScript}}</b-btn>
                </b-form-group>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </b-card>
    </div>
    <b-modal id="modal-center" ref="vueModal" centered title="Share" hide-footer>
      <div class="share-buttons">
        <input  id="input-url" :value="sharedUrl" style="opacity: 0;position: absolute;z-index: -1">
        <b-btn variant="primary" class="w-100"><a style="color:#FFF" target="_blank" :href="sharedUrlWithDetails" @click="sendEmail">{{lang.label.modal.shareScript}}</a></b-btn>
        <b-btn variant="primary" class="w-100"><a style="color:#FFF" href="javascript:void(0)" @click="openSmsModal">{{lang.label.modal.shareScriptSms}}</a></b-btn>
        <b-btn variant="primary" class="w-100 btn-copy"
               v-clipboard:copy= sharedUrl
               v-clipboard:success="onCopy"
               v-clipboard:error="onError"
               @click="copyToClipBoard1">{{lang.label.modal.copyScript}}</b-btn>
      </div>
    </b-modal>
      <b-modal
          id="modal-center1"
          ref="send_sms"
          centered
          :title="lang.label.modal.sendSmsTitle"
          hide-footer
      >
          <ValidationObserver ref="observer" v-slot="{ passes }">
              <b-form @submit.stop.prevent="passes(sendSms)">
                  <b-form-group>
                      <div class="row">
                          <div class="col-12 col-md-12">
                              <label class="label-control" for="name">
                                  {{lang.label.mobileNumber}}:
                                  <span class="text-danger">*</span>
                              </label>
                          </div>
                          <div class="col-12 col-md-12">
                              <ValidationProvider
                                  name="mobile number"
                                  :rules="{required:true,digits:10,regex:/^0[0-9].*$/}"
                                  v-slot="validationContext"
                              >
                                  <b-form-input
                                      :state="getValidationState(validationContext)"
                                      v-model="smsNumber"
                                      ref="prescription"
                                      type="text"
                                      :placeholder="lang.label.placeholder.enterMobileNumber"
                                  ></b-form-input>
                                  <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.mobileNumberRequired}}</b-form-invalid-feedback>
                                  <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.digits"> {{lang.label.validationMessages.mobilenumLength}}</b-form-invalid-feedback>
                                  <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.regex"> {{lang.label.validationMessages.startsWithZero}}</b-form-invalid-feedback>
                                  <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                              </ValidationProvider>
                          </div>
                      </div>
                      <div class="row mt-4">
                          <div class="col-12 col-md-12">
                              <label class="label-control" for="name">
                                  {{lang.label.smsContent}}:
                                  <span class="text-danger">*</span>
                              </label>
                          </div>
                          <div class="col-12 col-md-12">
                              <ValidationProvider
                                  name="sms content"
                                  rules="required"
                                  v-slot="validationContext"
                              >
                                  <b-form-textarea
                                      :state="getValidationState(validationContext)"
                                      v-model="smsContent"
                                      ref="prescription"
                                      type="text"
                                      :placeholder="lang.label.smsContent"
                                      rows="3"
                                      max-rows="3"
                                      disabled
                                  ></b-form-textarea>
                                  <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.prescriptionRequired}}</b-form-invalid-feedback>
                                  <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                              </ValidationProvider>
                          </div>
                      </div>
                  </b-form-group>
                  <div class="mt-3">
                      <b-btn type="submit" variant="primary" class="w-100">{{lang.label.buttons.send}}</b-btn>
                  </div>
              </b-form>
          </ValidationObserver>
      </b-modal>
    <b-modal
            id="modal-center2"
            ref="send_note"
            centered
            :title="lang.label.sendNoteToNurse"
            hide-footer
    >
      <ValidationObserver ref="observer" v-slot="{ passes }">
        <b-form @submit.stop.prevent="passes(sendNote)">
          <b-form-group>
            <div class="row">
              <div class="col-12 col-md-12">
                <label class="label-control" for="name">
                  {{lang.label.note}}:
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-12 col-md-12">
                <ValidationProvider
                        name="reason"
                        rules="required"
                        v-slot="validationContext"
                >
                  <b-form-textarea
                          :state="getValidationState(validationContext)"
                          v-model="note"
                          ref="prescription"
                          type="text"
                          :placeholder="lang.label.enterNote"
                          rows="3"
                          max-rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.noteRequired}}</b-form-invalid-feedback>
                  <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                </ValidationProvider>
              </div>
            </div>
          </b-form-group>
          <div class="mt-3">
            <b-btn type="submit" :disabled="onSend" variant="primary" class="w-100">{{lang.label.buttons.submit}}</b-btn>
          </div>
        </b-form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import jsondata from "../assets/json/data.json";
import moment from 'moment';
import $ from 'jquery';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import {mapGetters} from "vuex";
import Vue from "vue";
import Multiselect from 'vue-multiselect';

export default {
  components: {
    VueBootstrapTypeahead,
    Multiselect
  },
  computed: {
    ...mapGetters({
      login: "login",
      loading: "loading",
      patientInfo: "patientInfo",
      fromGroupRequests: "fromGroupRequests",
    }),
    emailId(){
      return this.modelsPharmacist.emailId;
    },
    emailIdPatient(){
      return this.models.emailId;
    },
    name(){
      return  this.modelsPharmacist.name;
    },
    number(){
      return this.modelsPharmacist.number;
    },
    mobileNumber(){
      return this.models.mobileNumber;
    },
    patientName(){
      return this.models.patientName;
    },
    isPharmacyReadonly() {
      // Check if pharmacy details exist from API or patientInfo
      const hasPharmacyName = (this.pharmacyData && this.pharmacyData.pharmacy_name) || 
                               (this.patientInfo && (this.patientInfo.pharmacyName || this.modelsPharmacist.name));
      const hasPharmacyMobile = (this.pharmacyData && this.pharmacyData.pharmacy_mobile) || 
                                 (this.patientInfo && (this.patientInfo.pharmacyMobile || this.patientInfo.pharmacyNumber || this.patientInfo.pharmacistMobile || this.modelsPharmacist.number));
      const hasPharmacyEmail = (this.pharmacyData && this.pharmacyData.pharmacy_email) || 
                               (this.patientInfo && (this.patientInfo.pharmacyEmail || this.modelsPharmacist.emailId));
      return hasPharmacyName || hasPharmacyMobile || hasPharmacyEmail;
    },
  },
  data() {
    return {
      icdCodeList: [],
      needToValidate: true,
      noteSent: false,
      onSend: false,
      status: [
        {item: true, name: "Is Patient a Minor?"},
      ],
      repeatedStatus: [
        {item: true, name: "Do you want to repeat the script?"},
      ],
      repeatMonthsOptions: [
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"},
        {value: 6, label: "6"},
      ],
      note: '',
      onlyPdf:false,
      newBeginning:true,
      zeroValue:false,
      maxValue: false,
      tariff: null,
      onlyImage:false,
      selectEmailOrMobile:false,
      selectEmailOrMobilePatient:false,
      noFilesChosen:false,
      mobileRequired:false,
      emailError:false,
      emailErrorPatient:false,
      pharmaNameError:false,
      pharmaMobileError:false,
      pdfLimit: 1,
      imageLimit: 6,
      pdfFlag:true,
      flagForNames: true,
      imageFlag:true,
      repeatMonthsError: false,
      mobileError: false,
      mobileErrorPharma: false,
      scriptId: '',
      pdfFiles: [],
      selectedDetailsPharmacist: [],
      imageFiles: [],
      imageRawFiles: [],
      sharedUrl: "",
      sharedUrlWithDetails: "",
      selectedPatient: null,
      selectedPharmacist: null,
      data: jsondata,
      datePickerOptions: {
        disabledDate (date) {
          return date > new Date()
        }
      },
      lang: this.$lang.script,
      fileList: [],
      endDate: "-1d",
      pharmacist: {},
      selectedDetails:[],
      signature: '',
      models: {
        patientName: "",
        mobileNumber: "",
        emailId: "",
        idNumber: "",
        patientMinor: [],
        parentName: "",
        parentIDNumber: "",
	      groupRequestId: 0,
	      icdCode: "",
        medicineRequired: "",
        specialInstructions: "",
        isRepeated: [true],
        repeatMonths: null,
        dob: "",
        gender: "",
        bloodGroup: "",
        address: "",
        prescription: "",
        appointmentId: "",
        formsManagementId:""
      },
      modelsPharmacist: {
        name: "",
        number: "",
        emailId: "",
      },
      patientList:[],
      nameError:false,
      pharmacistList:[],
      patientDetails:[],
      pharmacistDetails:[],
      pdfFile: '',
      submitted: false,
      gender: [{ value: "Male" }, { value: "Female" }, { value: "Other" }],
      bloodGroup: [
        { value: "O+" },
        { value: "O-" },
        { value: "AB+" },
        { value: "AB-" },
        { value: "A+" },
        { value: "A-" },
        { value: "B+" },
        { value: "B-" }
      ],
      imageFile: null,
	    smsNumber:"",
	    smsContent:"",
	    smsMessage:"",
      pharmacyData: {}
    };
  },
  watch: {

    tariff(val){
      if(val < 0){
        this.tariff = '';
        this.maxValue = false;
      } else if (val && parseInt(val) > 100000) {
        this.maxValue = true;
      } else {
        this.maxValue = false;
      }
    },
    name(val){
      if(this.flagForNames){
        if(val){
          this.pharmaNameError = false;
        }
        if(this.modelsPharmacist.emailId || this.modelsPharmacist.number || !val){
          this.emailError = false;
          this.pharmaMobileError = false;
        }
      }
      this.flagForNames = true;
    },
    emailIdPatient(val){
      if(val){
        this.emailError = false;
        this.selectEmailOrMobilePatient = false;
      }
      if((this.models.patientName || this.models.mobileNumber )|| !val){
        this.nameError = false;
        this.mobileError = false;
      }else{
        if(!this.$refs.patientName.inputValue){
          this.nameError = true;
        }
      }
    },
    emailId(val){
      if(val){
        this.emailError = false;
        this.selectEmailOrMobile = false;
      }
      if((this.modelsPharmacist.name || this.modelsPharmacist.number )|| !val){
        this.pharmaNameError = false;
        this.pharmaMobileError = false;
      }else{
        this.pharmaNameError = true;
      }
    },
    number(val) {
	    if (val) {
		    this.pharmaMobileError = false;
		    this.selectEmailOrMobile = false;
	    }
	    if (this.modelsPharmacist.name || this.modelsPharmacist.emailId || !val) {
		    this.pharmaNameError = false;
		    this.emailError = false;
	    } else {
		    this.pharmaNameError = true;
	    }
	    if (val && val.slice(0, 1) != 0) {
		    this.mobileErrorPharma = true;
	    } else {
		    this.mobileErrorPharma = false;
	    }
    },
    patientName(val){
      if(this.flagForNames){
        if(val){
          this.nameError = false;
        }else{
          if(!this.newBeginning){
            this.nameError = true;
          }
          this.newBeginning = false;
        }
      }
      this.flagForNames = true;
    },
    mobileNumber(val){
      if(val){
        this.mobileRequired = false;
        this.selectEmailOrMobilePatient = false;
      }
      if(val.slice(0,1) != 0){
        this.mobileError = true;
      }else{
        this.mobileError = false;
      }
    },
    fileList: function(val){
    },
    selectedPatient: function (val) {
      if(val) {
        this.selectedDetails = this.patientDetails.filter(c => {
          return c.id == val.id;
        });

        if(this.selectedDetails[0].isMinor){
          this.models.patientMinor.push(this.status[0].item);
        }else{
          this.models.patientMinor = [];
        }
        this.models.name = this.selectedDetails[0].name;
        this.models.parentName = this.selectedDetails[0].parentName;
        this.models.parentIDNumber = this.selectedDetails[0].idNumberParent;
        this.models.medicineRequired = this.selectedDetails[0].medicine;
        this.models.idNumber = this.selectedDetails[0].idNumber;
        this.models.specialInstructions = this.selectedDetails[0].specialInstructions;
        this.models.address = this.selectedDetails[0].address;
        this.models.bloodGroup = this.selectedDetails[0].bloodGroup;
        this.models.dob = this.selectedDetails[0].dob;
        this.models.emailId = this.selectedDetails[0].email;
        let gender = '';
        gender = this.selectedDetails[0].gender;
        if (gender) {
          this.models.gender = gender == 1 ? "Male" : (gender == 2 ? "Female" : "Other");
        } else {
          this.models.gender = '';
        }
        this.models.mobileNumber = this.selectedDetails[0].mobile;
        this.tariff = this.selectedDetails[0].tariff;
      }
    },
    selectedPharmacist: function (val) {
      if(val) {
        this.selectedDetailsPharmacist = this.pharmacistDetails.filter(c => {
          return c.id == val.id;
        });
        this.modelsPharmacist.emailId = this.selectedDetailsPharmacist[0].email;
        this.modelsPharmacist.number = this.selectedDetailsPharmacist[0].mobile;
      }
    }
  },
  mounted(){
    console.log(this.patientInfo)
    this.listenForNameBlur();
    this.listenForModalClose();
    this.fetchPharmacyData();
    this.getPatientList();
    this.getPharmacistList();
    this.getICDcodes();
    this.tariff =  this.login.myScriptPrice;
  },
  methods: {
    fetchPharmacyData(){
      this.$store.dispatch('fetchDoctorData').then(response => {
        if (response && response.status == 200 && response.data) {
          const doctorData = response.data.data || response.data;
          if (doctorData) {
            // Store pharmacy data
            this.pharmacyData = {
              pharmacy_name: doctorData.pharmacy_name || '',
              pharmacy_email: doctorData.pharmacy_email || '',
              pharmacy_mobile: doctorData.pharmacy_mobile || ''
            };
            // Populate pharmacy fields if they exist and are not already set from patientInfo
            if (this.pharmacyData.pharmacy_name && !this.modelsPharmacist.name) {
              this.modelsPharmacist.name = this.pharmacyData.pharmacy_name;
              if(this.$refs.pharmacistName) {
                this.$refs.pharmacistName.inputValue = this.pharmacyData.pharmacy_name;
              }
            }
            if (this.pharmacyData.pharmacy_mobile && !this.modelsPharmacist.number) {
              this.modelsPharmacist.number = this.pharmacyData.pharmacy_mobile;
            }
            if (this.pharmacyData.pharmacy_email && !this.modelsPharmacist.emailId) {
              this.modelsPharmacist.emailId = this.pharmacyData.pharmacy_email;
            }
          }
        }
      }).catch(error => {
        console.error('Error fetching pharmacy data:', error);
      });
    },
    getICDcodes(){
      this.$store.dispatch('icd10Codes').then(response => {
        if(response.status == 200) {
          this.icdCodeList = response.data.data;
        }
      })
    },
    listenForNameBlur(){
      $("#patientName input").blur(function(){
        this.needToValidate = true;
      });
    },
    openNoteModal() {
      this.$refs.send_note.show();
    },
    sendNote(){
      let self = this;
      self.onSend=true;
      let params = {
        "note": this.note,
        "formsManagementId": this.models.formsManagementId
      };
      this.$store.dispatch('sendNoteToNurse', params).then(value => {
        self.noteSent = true;
        self.$refs.send_note.hide();
        self.onSend = false;
        if (value.message) {
          self.$alert(value.message, '', {
            confirmButtonText: 'OK',
            callback: action => {
              self.$bvModal.show('modal-center');
            }
          });
        }
      })
    },
    listenForModalClose(){
      let _this = this;
      this.$root.$on('bv::modal::hide', (bvModalEvent, modalId ) => {
        if(this.$route.name == 'create-electronic-script' || this.$route.name == 'create-script') {
          let smsModal = $(this.$refs['send_sms'])[0];
          if (smsModal && smsModal.isHidden) {
            _this.smsNumber = '';
          }
          if (modalId == 'modal-center2' && !_this.noteSent) {
            _this.$bvModal.show('modal-center');
          }
          if (modalId != 'modal-center') {
            if (Object.keys(this.patientInfo).length) {
              if (this.models.groupRequestId != null) {
                let noteModal = $(_this.$refs['send_note'])[0];
                if (noteModal && noteModal.isHidden) {
                  _this.$router.push({name: 'group-request-list'});
                }
              } else {
                this.$router.push({name: 'script-requests'});
              }
            }
          } else {
            _this.clearAll()
          }
        }
      })
    },
    isNumber(type,evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(type == 1){
        if(this.models.mobileNumber.length >= 10){
          evt.preventDefault();
        }
      }
      if(type == 2){
        if(this.modelsPharmacist.number.length >= 10){
          evt.preventDefault();
        }
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getPatientList(){
      this.$store.dispatch('getPatientDetails').then(response => {
        if(response.data){
          this.patientDetails = response.data;
          response.data.forEach((object) => {
            this.patientList.push({name: object.name,mobile:object.mobile,id: object.id});
          });
          if(Object.keys(this.patientInfo).length){
            this.models.patientName = this.patientInfo.name;
            this.models.mobileNumber = this.patientInfo.mobile;
            this.models.emailId = this.patientInfo.email;
            this.models.idNumber = this.patientInfo.idNumber;
            this.models.icdCode = this.patientInfo.icdCode? this.patientInfo.icdCode : '';
            this.models.dob = this.patientInfo.dob;
            this.models.groupRequestId = this.patientInfo.formsManagementId!==null?this.patientInfo.formsManagementId:'';
            if(this.patientInfo.gender){
              this.models.gender = this.patientInfo.gender == 1 ? "Male" : (this.patientInfo.gender == 2 ? "Female" : "Other");
            }
            this.models.bloodGroup = this.patientInfo.bloodGroup;
            this.models.address = this.patientInfo.address;
            if(this.patientInfo.isMinor){
              this.models.patientMinor.push(this.status[0].item);
            }
            this.models.name = this.patientInfo.name;
            // Use pharmacy data from patientInfo if available, otherwise use API data
            this.modelsPharmacist.name = this.patientInfo.pharmacyName || (this.pharmacyData && this.pharmacyData.pharmacy_name) || "";
            this.modelsPharmacist.number = this.patientInfo.pharmacyMobile || this.patientInfo.pharmacyNumber || this.patientInfo.pharmacistMobile || (this.pharmacyData && this.pharmacyData.pharmacy_mobile) || "";
            this.modelsPharmacist.emailId = this.patientInfo.pharmacyEmail || (this.pharmacyData && this.pharmacyData.pharmacy_email) || "";
            // old
            this.models.formsManagementId=this.patientInfo.formsManagementId!==null?this.patientInfo.formsManagementId:'';
            // this.models.groupRequestId = this.patientInfo.formsManagementId!==null?this.patientInfo.formsManagementId:'';
            this.models.parentName = this.patientInfo.parentName;
            this.models.parentIDNumber = this.patientInfo.idNumberParent;
            this.models.medicineRequired = this.patientInfo.medicine ? this.patientInfo.medicine : this.patientInfo.medication;
            this.models.specialInstructions = this.patientInfo.specialInstructions;
            // Ignore API isRepeated and keep checkbox selected by default.
            this.models.isRepeated = [this.repeatedStatus[0].item];

            if (this.patientInfo.repeatMonths !== undefined && this.patientInfo.repeatMonths !== null && this.patientInfo.repeatMonths !== '') {
              this.models.repeatMonths = this.patientInfo.repeatMonths;
            } else {
              this.models.repeatMonths = null;
            }
            this.$refs.patientName.inputValue = this.patientInfo.name
            this.models.patientId = this.patientInfo.patientId;
            this.$refs.pharmacistName.inputValue = this.patientInfo.pharmacyName || (this.pharmacyData && this.pharmacyData.pharmacy_name) || "";
            // if(this.patientInfo.pharmacistName != null) {
	       
	            // this.modelsPharmacist.emailId = this.patientInfo.clinicEmail;
            // }
            this.models.appointmentId = this.patientInfo.appointmentId;
          }
        }
      });
    },
    getPharmacistList(){
        let info = {
          "pageNo" : 0,
          "search" : ""
        };
       this.$store.dispatch('getPharmacistDetails',info).then(response => {
      if(response.data){
        this.pharmacistDetails = response.data;
        response.data.forEach((object,index) => {
          this.pharmacistList.push({name: object.name,location: object.location,mobile: object.mobile,id: object.id});
        });
      }
    });
    },
    open() {
      let self = this;
      this.$alert(this.lang.label.scriptCreated, '', {
        confirmButtonText: 'OK',
        callback: action => {
          if(self.fromGroupRequests){
            self.$store.commit('setFromGroupRequests', false);
            self.wantToSendNote();
          }else{
            self.$bvModal.show('modal-center');
          }
        }
      });
    },
    wantToSendNote(){
      let self = this;
      this.$swal.fire({
        title: '',
        text: self.lang.label.sendNote,
        type: '',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        allowOutsideClick: false
      }).then((result) => {
        if(result.value){
          self.openNoteModal();
        }else{
          self.$bvModal.show('modal-center');
        }
      })
    },
	openSmsModal() {
          if(this.models.mobileNumber){
            this.smsNumber  = this.models.mobileNumber;
          }
          this.$bvModal.show('modal-center1');
    },
    closeSmsModal() {
		  this.$alert(this.lang.label.smsSent, '', {
			  confirmButtonText: 'OK',
			  callback: action => {
				  this.$bvModal.hide('modal-center1');
			  }
		  });
	  },
    clearAll(){
              let self = this;
              this.$store.commit('setPatientInfo',{});
              this.models.mobileNumber= "";
              this.models.parentName= "";
              this.models.parentIDNumber= "";
              this.models.medicineRequired= "";
              this.models.idNumber= "";
              this.models.specialInstructions= "";
              this.models.isRepeated = [true];
              this.models.repeatMonths = null;
              this.models.patientMinor = [];
              this.models.icdCode = "";
              this.newBeginning = true;
              this.models.emailId= "";
              this.models.dob= "";
              this.models.gender= "";
              this.models.bloodGroup= "";
              this.models.address= "";
              this.models.prescription= "";
              this.models.groupRequestId= 0;
              this.modelsPharmacist.number= "";
              this.modelsPharmacist.emailId= "";
              this.models.formsManagementId="";
              this.flagForNames = false;
              this.models.patientName = '';
              this.modelsPharmacist.name = '';
              if(this.$refs.patientName) this.$refs.patientName.inputValue = "";
              if(this.$refs.pharmacistName) this.$refs.pharmacistName.inputValue = "";
              if(this.$refs.icd10Code) this.$refs.icd10Code.inputValue = "";
              this.imageFiles = [];
              this.pdfFiles = [];
              if(this.$refs.observer){
                this.needToValidate = true;
                this.$refs.observer.reset();
              }else{
                this.needToValidate = false;
              }
              this.$refs.imageUpload ? this.$refs.imageUpload.clearFiles() : '';
              this.$refs.pdfUpload ? this.$refs.pdfUpload.clearFiles() : '';
              this.selectedDetails= [];
              this.patientList = [];
              this.pharmacistList = [];
              this.selectedDetailsPharmacist = [];
              this.selectedPatient = null;
              this.selectedPharmacist = null;
              this.errorClear();
              this.getPatientList();
              this.getPharmacistList();
    },
    errorClear(){
      this.mobileError = false;
      this.mobileErrorPharma = false;
      this.pharmaMobileError = false;
      this.emailErrorPatient = false;
      this.emailError = false;
      this.mobileError = false;
      this.pharmaNameError = false;
      this.nameError = false;
      this.selectEmailOrMobile = false;
      this.selectEmailOrMobilePatient = false;
      this.repeatMonthsError = false;
    },
    createScript(e){
      if(parseInt(this.tariff) < 0){
        this.zeroValue = true;
        this.maxValue = false;
        if (e) e.preventDefault();
      } else if(parseInt(this.tariff) > 100000){
        this.maxValue = true;
        this.zeroValue = false;
        if (e) e.preventDefault();
      }else{
        this.zeroValue = false;
        this.maxValue = false;
      }
      if(this.pdfFiles.length+this.imageFiles.length < 1){
        window.scrollTo(0,0);
        this.noFilesChosen = true;
      }else{
        this.noFilesChosen = false;
      }
      if(!this.$refs.patientName.inputValue){
        window.scrollTo(0,0);
        this.nameError = true;
      }
    },
    onCopy: function (e) {
      this.notifyVue('success');
    },
    onError: function (e) {
      this.notifyVueError('error');
    },
    notifyVue(type = 'success') {
      this.$notify({
        message: 'Link copied Successfully!!',
        timeout: 5000,
        type
      });
      if(type = 'success'){
        this.$router.push({name: 'home'});
      }
    },
    notifyVueError(type = 'error') {
      this.$notify({
        message: 'Failed to copy link',
        timeout: 5000,
        type
      });
    },
    sendEmail(){
      this.$bvModal.hide('modal-center');
      this.$router.push({name: 'home'});
    },
    copyToClipBoard1() {
      var copyText = document.getElementById("input-url");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.$bvModal.hide('modal-center');
    },
    maxPdfReached(){
      this.$swal.fire({
        title: 'Maximum files limit reached',
        text: 'Max ' +this.pdfLimit+' pdf can be uploaded.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      })
    },
    maxFileReached(files,fileList){
      this.$swal.fire({
        title: '',
        text: 'Max '+this.imageLimit+' images can be uploaded.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      })
    },
    handleChange(file,fileList){
      let self = this;
      if(fileList.length){
        let nonImage = fileList.filter((object,index) => {return !object.raw.type.includes("image")});
        if(nonImage.length){
          this.onlyImage = true;
          self.$refs.imageUpload.clearFiles();
        }else {
          this.onlyImage = false;
          if(fileList.length == 6){
              self.pdfLimit = 0;
              self.imageLimit = 6;
          }
        }
        this.noFilesChosen = false;
      }
      this.imageFiles = fileList;
    },
    getImgUrl(pic) {
      return require("../assets/styles/img/" + pic);
    },
    getValidationState({ dirty, validated, valid = null }) {
      if(this.mobileError){
        return false;
      }else if (this.mobileErrorPharma){
        return false;
      }else{
        return dirty || validated ? valid : null;
      }
    },
    onSubmit() {
      if(this.pdfFiles.length+this.imageFiles.length) { // check if image or pdf is chosen or ot
        if(!this.$refs.patientName.inputValue){ //custom validation for patient's name
          this.nameError = true;
          window.scrollTo(0,0);
          return true;
        }
        if(this.zeroValue || this.maxValue){
          return true;
        }
        const repeatMonths = parseInt(this.models.repeatMonths, 10);
        const repeatMonthsValid =
          Number.isInteger(repeatMonths) && repeatMonths >= 1 && repeatMonths <= 6;
        if (this.models.isRepeated && this.models.isRepeated.length > 0 && !repeatMonthsValid) {
          this.repeatMonthsError = true;
          window.scrollTo(0,0);
          return true;
        } else {
          this.repeatMonthsError = false;
        }
        let emailPatient = this.models.emailId;
        let namePatient = this.models.patientName;
        let numberPatient = this.models.mobileNumber;
        let email = this.modelsPharmacist.emailId;
        let name = this.modelsPharmacist.name;
        let number = this.modelsPharmacist.number;
        if((this.nameError && this.emailErrorPatient && this.mobileError) ||(numberPatient && !namePatient) || ((namePatient && !numberPatient) && (namePatient && !emailPatient)) || (!namePatient && emailPatient)){
          window.scrollTo(0,0);
          this.selectEmailOrMobilePatient = true;
          return true;
        }
        console.log('pharmaNameError',this.pharmaNameError,this.emailError,this.pharmaMobileError,number,name,email);
        if((this.pharmaNameError && this.emailError && this.pharmaMobileError) || (number && !name) || ((name && !number) && (name && !email)) || (!name && email)){
          this.selectEmailOrMobile = true;
          return true;
        }else{
          this.selectEmailOrMobile = false;
        }
        this.noFilesChosen = false;
        if (!this.mobileError) {
          let self = this;
          this.submitted = true;
          let date_of_birth = '';
          if(this.models.dob){
            date_of_birth = moment(this.models.dob).format("YYYY-MM-DD");
          }
          let gender = '';
          gender = this.models.gender;
          if(gender){
            gender = gender ==   "Male" ? 1 : (gender == "Female" ? 2 : 3) ;
          }else{
            gender = '';
          }
          let scriptType = 0;
          let scriptPrice = this.tariff || this.tariff ==0 ? parseInt(this.tariff) : '';
          let data = {};
          data = {
            "scriptType": scriptType,
            "patientId": this.selectedDetails[0] && this.selectedDetails[0].id ? this.selectedDetails[0].id :(Object.keys(this.patientInfo).length) && this.patientInfo.patientId ? this.patientInfo.patientId :  0,
            "name": this.models.patientName,
            "email": this.models.emailId,
            "mobile": this.models.mobileNumber,
            "gender": gender,
            "bloodGroup": this.models.bloodGroup,
            "icdCode": this.models.icdCode,
            "dob": date_of_birth,
            "address": this.models.address,
            "pharmacistName": this.modelsPharmacist.name,
            "pharmacistEmail": this.modelsPharmacist.emailId,
            "pharmacistMobile": this.modelsPharmacist.number,
            "scriptPrice": scriptPrice,
            "formsManagementId":this.models.formsManagementId,
            "prescription": "",
            "groupRequestId": this.models.groupRequestId,
            "pharmacistId": this.selectedDetailsPharmacist[0] && this.selectedDetailsPharmacist[0].id ? this.selectedDetailsPharmacist[0].id :(Object.keys(this.patientInfo).length) && this.patientInfo.pharmacistId ? this.patientInfo.pharmacistId :  0,
          };
           console.log(this.selectedDetailsPharmacist)
           console.log(this.selectedDetails)
           console.log(this.patientInfo)
          if(Object.keys(this.patientInfo).length){
            if(this.models.idNumber){
              data.idNumber=this.models.idNumber;
            }
            data.isMinor=this.models.patientMinor.length ? 1 : 0;
            if(this.models.parentName){
              data.parentName=this.models.parentName;
            }
            if(this.models.parentIDNumber){
              data.idNumberParent=this.models.parentIDNumber;
            }
            if(this.models.medicineRequired){
              data.medicine=this.models.medicineRequired;
            }
            if(this.models.specialInstructions){
              data.specialInstructions=this.models.specialInstructions;
            }
          }
          // Include isRepeated and repeatMonths for all cases
          if(this.models.isRepeated && this.models.isRepeated.length > 0){
            data.isRepeated = this.models.isRepeated.includes(true) ? 1 : 0;
          } else {
            data.isRepeated = 0;
          }
          if(this.models.repeatMonths){
            data.repeatMonths = this.models.repeatMonths;
          }
          if(this.models.appointmentId){
            data.appointmentId = this.models.appointmentId;
          }
          this.$store.dispatch('createScript', data).then(value => {
            if (value.data) {
              this.getICDcodes();
              self.sharedUrl = value.data.sharedURL;
              self.sharedUrlWithDetails = self.scriptDetails();
	            self.smsContent=self.scriptSmsDetails();
	            self.scriptId = value.data.id;
              let formData = new FormData();
              formData.append('scriptId', self.scriptId);
              self.imageFiles.forEach((object, index) => {
                formData.append('scriptImage[' + index + ']', object.raw);
              });
              let increment = self.imageFiles.length;
              self.pdfFiles.forEach((object, index) => {
                formData.append('scriptImage[' + (index + increment) + ']', object.raw);
              });
              self.$store.dispatch('uploadImages', formData).then(value => {
                if (value) {
                  self.open();
                }
              });
            }
          });
        } else {
          if (this.mobileError) {
            $("#mobileError").focus();
          } else {
            $("#mobileErrorPharma").focus();
          }
        }
      }else{
        window.scrollTo(0,0);
        this.noFilesChosen = true;
      }
  },
    sendSms() {

	      let self = this;
	      let data = {};
	      data = {
		      "message": this.smsContent,
		      "mobile": this.smsNumber,
	      };
	      this.$store.dispatch('shareScriptViaSMS', data).then(value => {
		      if (value.data) {
			      self.closeSmsModal();
			      self.$router.push({name: 'home'});
		      }
	      });
      },
    scriptDetails(){
      let subject = 'mailto:'+this.models.emailId+'?subject=Payscript – Script / Form from '+this.login.practiceName+' &body=';
      let body;
      if(this.tariff == 0){
        body = 'Dear '+this.models.patientName+','+'%0D%0A%0D%0A'+'You submitted a request for a script / form to '+this.login.practiceName+'. If you requested the document, please '+'OPEN '+this.sharedUrl+' to access the document.'+'%0D%0A%0D%0A'+'Thank you, %0D%0A'+this.login.practiceName;
      }else{
        body = 'Dear '+this.models.patientName+','+'%0D%0A%0D%0A'+'You submitted a request for a script / form to '+this.login.practiceName+'. If you requested the document, please '+'OPEN '+this.sharedUrl+' to pay and access the document.'+'%0D%0A%0D%0A'+'Thank you, %0D%0A'+this.login.practiceName;
      }
      return subject+body;
    },
      scriptSmsDetails() {
	      let body;
	      body = 'Dear ' + this.models.patientName + ',' + ' You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please click this link ' + this.sharedUrl + '  to download the document.';
	      return body;
      },
    /*convert()
    {
        var text1=document.getElementById("input-url");
        let text = text1.value;
        var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        var text1=text.replace(exp, "<a href='$1'>$1</a>");
        var exp2 =/(^|[^\/])(www\.[\S]+(\b|$))/gim;
        // document.getElementById("converted_url").innerHTML=text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
    },*/
    handleRemove(file, fileList) {
      this.imageFiles = fileList;
      this.imageLimit = 6;
      this.pdfLimit = 1;
    },
    handlePreview(file) {
    },
    handleRemovePdf(file, fileList){
      this.pdfFiles = fileList;
      this.imageLimit = 6;
      this.pdfLimit = 1;
    },
    handleChangePdf(file, fileList){
      let self = this;
      let nonPdf = fileList.filter((object,index) => {return object.raw.type != "application/pdf"});
      if(nonPdf.length){
        this.onlyPdf = true;
      self.$refs.pdfUpload.clearFiles();
      }else if(self.pdfLimit == 0){
        self.$refs.pdfUpload.clearFiles();
        self.$swal.fire({
          title: 'Maximum files limit reached',
          text: 'You can upload maximum 6 files in total',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        })
      }else{
        this.onlyPdf = false;
        this.pdfFiles = fileList;
        if(fileList.length){
          self.imageLimit = 5;
          this.pdfLimit = 1;
          this.noFilesChosen = false;
        }
      }
    },
    beforeAvatarUpload(file){
      /*const isJPG = file.type === 'image/jpeg';
      if (!isJPG) {
        this.$message.error('Avatar picture must be JPG format!');
      }*/
    }
  },
  destroyed() {
    this.$store.commit('setPatientInfo',{});
  }
};
</script>
